export default __webpack_public_path__ + "static/media/img_video.ebb14f06.png";